import {View} from "react-native";
import {Rating} from "@kolking/react-native-rating";
import TextM from "../text/TextM";
import {theme} from "../../theme/theme";
import React from "react";
import sparkle from "../../../../assets/icons/stars/sparkle_filled.png"

export function RatingM({score, color, size = 40, readonly = true, style, noMargin, noText, scale = 5}) {

    return <View style={{
        flexDirection: "row",
        alignItems: "center",
        ...style
    }}>
        <Rating
            maxRating={scale}
            rating={score ?? 0}
            baseSymbol={sparkle}
            fillSymbol={sparkle}
            size={size}
            readonly={readonly}
            fillColor={color ?? theme.colors.accent}
            touchColor={theme.colors.material.secondary["700"]}
            style={{
                marginTop: noMargin ? 7 : 10,
                marginBottom: noMargin ? 0 : 20,
            }}
        />
        {!noText && <TextM fontSize={size * 0.52}
                           fontWeight="SemiBold"
                           style={{
                               position: "absolute",
                               right: size < 40 ? -size : -size * 3 / 2,
                               paddingBottom: 5
                           }}
                           color={color ?? theme.colors.accent}>{score ? (Math.round(score * 10) / 10 ?? 0) : ""}</TextM>}
    </View>;
}